<template>
<b-container fluid>
  <b-alert v-if="alert.message != ''" :variant="alert.variant">{{alert.message}}</b-alert>
  <h1>Backordered Part Info</h1>
  <b-row align-h="center">
    <b-form @submit="searchParts" inline>
      <b-form-input placeholder="Part Number" v-model="form.partNumber" class="mx-1" />
      <b-btn type=submit variant=primary class="mx-1">Search Parts</b-btn>
    </b-form>
  </b-row>
  <section v-if="items.length != 0" class="mx-2">
    <b-row class="mt-2">
      <b-col cols=8>
        <b-form-input v-model="filter" placeholder="Filter" />
      </b-col>
      <b-col>
        <b-pagination
          :current-page="currentPage" :per-page="perPage"
          :total-rows="totalRows" v-model="currentPage"
          align="right" class="mb-0"
        />
      </b-col>
    </b-row>
    <b-row class="my-1">
      <b-table
        :items="items" :fields="fields" class="my-0"
        :busy="busy" :current-page="currentPage" :per-page="perPage"
        :filter="filter" @filtered="onFilter"
      >
        <template slot="sonum" slot-scope="data">
          <router-link target="_blank" :to="{ name: 'View Order', params: { id: data.item.sonum } }">
            {{data.item.sonum}}
          </router-link>
        </template>
      </b-table>
    </b-row>
  </section>
</b-container>
</template>

<script>
import axios from 'axios';
import NiceDate from '../utility/NiceDate';
const BASE_API = process.env.VUE_API_ROOT;

export default {
  components: {
    NiceDate,
  },
  data() {
    return {
      alert: {
        variant: 'danger',
        message: '',
      },
      form: {
        partNumber: '',
      },
      busy: false,
      fields: [
        { key: 'sonum', label: 'SO Number', sortable: true },
        { key: 'dateissued', label: 'Date Issued', sortable: true },
        { key: 'prioritytext', label: 'Priority', sortable: true },
        { key: 'partnum', label: 'Part Number', sortable: true },
        { key: 'qty', label: 'Quantity', sortable: true },
        { key: 'shipmethod', label: 'Ship Method', sortable: true },
        { key: 'statustext', label: 'Status', sortable: true },
        { key: 'note', label: 'Note', sortable: true },
      ],
      items: [],
      filter: '',
      perPage: 20,
      currentPage: 1,
      totalRows: 0,
    };
  },
  methods: {
    searchParts(evt) {
      evt.preventDefault();
      this.alert.message = '';

      this.busy = true;
      axios(`${BASE_API}/fishbowl/parts/backordered/${this.form.partNumber}`).then((response) => {
        this.items = response.data;
        this.totalRows = this.items.length;
        if (this.totalRows == 0) {
          this.alert.variant = 'warning';
          this.alert.message = 'No Orders Found';
        }
        this.busy = false;
      }).catch((error) => {
        this.alert.variant = 'danger';
        this.alert.message = 'Search Failed. See console for more information';
        console.error(error);
      })
    },
    onFilter(items) {
      this.totalRows = items.length;
      this.currentPage = 1;
    },
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/sales-order/BackorderedPartInfo.vue